import { render, staticRenderFns } from "./add.vue?vue&type=template&id=4d801c8b&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=4d801c8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d801c8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d801c8b')) {
      api.createRecord('4d801c8b', component.options)
    } else {
      api.reload('4d801c8b', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=4d801c8b&scoped=true&", function () {
      api.rerender('4d801c8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/recovery/components/add.vue"
export default component.exports